import { palette } from "../../../../../theme/palette";
const theme = palette('light');
export const cardStyle = {
    background: theme.common.white,
    borderRadius: "25px",
    padding: '10px 25px',
    width: "100%",
};
